export default __webpack_public_path__ + "static/media/logo_archivo.e62fa17b.svg";